module.exports = __webpack_public_path__ + "img/91135.052a7fce.svg";